import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { UI } from '../../../global'
import useStyles from './styles'
import { REPLACEMENT_PARTS_PATH } from '../../constants'
import ReplacementPartsForm from '../../forms/ReplacementPartsForm'

export interface CustomerInsuranceProps {
  id: string
}
export interface ReplacementPartsViewProps extends UI.LifeCycle {
  order: APIResponse.DME.Order
  products: APIResponse.CatalogCategoryProduct[]
  insurance: CustomerInsuranceProps
  subscription?: APIResponse.DME.Subscription
}

const ReplacementPartsView: UI.ViewComponent<ReplacementPartsViewProps> =
  observer(
    ({
      insurance,
      order,
      products,
      subscription,
      onComponentDidMount,
    }: ReplacementPartsViewProps) => {
      const classes = useStyles()

      useEffect(() => {
        onComponentDidMount()
      }, [])

      return (
        <div className={classes.viewContainer}>
          <ReplacementPartsForm
            customerInsuranceId={insurance.id}
            order={order}
            productOptions={products}
            subscriptionId={subscription?.id}
          />
        </div>
      )
    }
  )

ReplacementPartsView.location = (router) => {
  if (router) {
    router.push(REPLACEMENT_PARTS_PATH)
  } else {
    window.location.href = REPLACEMENT_PARTS_PATH
  }
}

export default ReplacementPartsView
